import React, { useContext } from "react";
import { generatePath, useParams } from "react-router-dom";

const BaseRoutePathContext = React.createContext<{
  route: string;
  path: string;
}>({ route: "", path: "" });

export function useBaseRoutePathContext() {
  return useContext(BaseRoutePathContext);
}
export function BaseRoutePathProvider({
  route,
  children,
}: {
  route: string;
  children: React.ReactNode;
}) {
  const currentBase = useBaseRoutePathContext();
  const params = useParams();
  const newRoute = `${currentBase.route ?? ""}${route}`;
  const newPath = generatePath(newRoute, params);
  return (
    <BaseRoutePathContext.Provider value={{ route: newRoute, path: newPath }}>
      {children}
    </BaseRoutePathContext.Provider>
  );
}
